const dores = [
  {
    icon: 'ri-map-2-line',
    title: 'Sem diagnóstico do negócio',
    desc: 'Você não sabe por onde começar. Falta uma visão clara de onde estão os gargalos e oportunidades.',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Desorganização operacional',
    desc: 'Processos na cabeça, retrabalho constante, equipe sem direção. A operação não funciona sozinha.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Caos financeiro',
    desc: 'Não sabe quanto gasta, quanto fatura, se tem lucro. O controle financeiro é uma planilha bagunçada ou não existe.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Vendas inconsistentes',
    desc: 'Um mês vai bem, no outro cai. Não há pipeline organizado, processo claro de vendas ou previsibilidade.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Estagnação',
    desc: 'O negócio não cresce. Mesmas ofertas, mesmas estratégias, mesmas operações. Sem diferenciação ou inovação.',
  },
  {
    icon: 'ri-robot-line',
    title: 'Fora do ritmo tecnológico',
    desc: 'Ferramentas manuais, processos lentos, sem automação. A tecnologia existe para simplificar, mas não é usada.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Vulnerabilidade jurídica',
    desc: 'Contratos improvisados, documentos soltos, riscos desnecessários. A estrutura legal é frágil e vulnerável.',
  },
];

export default function DoresSection() {
  return (
    <section id="dores" className="py-24 md:py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-stone-400 mb-4">
            Você se identifica com isso?
          </p>
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 leading-tight">
            OS 7 PROBLEMAS QUE<br />
            <span className="text-red-600">TRAVAM SEU NEGÓCIO</span>
          </h2>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {dores.map((dor, i) => (
            <div
              key={dor.title}
              className="bg-white rounded-2xl p-8 border border-stone-100 hover:border-red-100 transition-all group"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-red-50 group-hover:bg-red-100 transition-colors mb-6">
                <i className={`${dor.icon} text-red-600 text-2xl`} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{dor.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{dor.desc}</p>
            </div>
          ))}

          {/* Quebra de crença card */}
          <div className="bg-gray-900 rounded-2xl p-8 flex flex-col justify-between">
            <div>
              <p className="text-white/50 text-sm font-medium mb-4 uppercase tracking-widest">A verdade é:</p>
              <p className="text-2xl md:text-3xl font-black text-white leading-tight">
                Mais esforço não resolve um negócio desorganizado.
              </p>
            </div>
            <p className="text-amber-400 text-xl font-bold mt-6">Estrutura resolve.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
